import type { I18N } from '@vista-digital/i18n'
import type {
    CompletedStandardOrder,
    Film,
    InProgressOrder,
    OrderItemLine,
    OrderTicketLine,
    Showtime,
    Site,
} from '@vista-digital/ocapi-types/v1'
import { gtm } from '../../gtm.service'
import { Ecommerce, EcommerceDataLayer } from '../../models-gtm'
import { getConcessionCartShowtimeItems } from '../../utils/getConcessionCartShowtimeItems'
import { getTicketItems } from '../../utils/getTicketItems'
import { groupShowtimeItemsByQuantity } from '../../utils/groupShowtimeItemsByQuantity'

export class PaymentGtmEvents {
    public static beginCheckout(
        order: InProgressOrder,
        ticketLines: OrderTicketLine[],
        orderItems: OrderItemLine[],
        film: Film,
        site: Site,
        showtime: Showtime,
        i18n: I18N
    ) {
        const ecommerceData = getPaymentEcommerceModel(order, ticketLines, orderItems, film, site, showtime, i18n)
        gtm.sendDataLayer(new EcommerceDataLayer('begin_checkout', ecommerceData))
    }

    public static addPaymentInfo(
        order: InProgressOrder,
        ticketLines: OrderTicketLine[],
        orderItems: OrderItemLine[],
        film: Film,
        site: Site,
        showtime: Showtime,
        i18n: I18N
    ) {
        const ecommerceData = getPaymentEcommerceModel(order, ticketLines, orderItems, film, site, showtime, i18n)
        gtm.sendDataLayer(new EcommerceDataLayer('add_payment_info', ecommerceData))
    }

    public static payment(
        order: CompletedStandardOrder,
        ticketLines: OrderTicketLine[],
        orderItems: OrderItemLine[],
        film: Film,
        site: Site,
        showtime: Showtime,
        i18n: I18N
    ) {
        const ecommerceData = getPaymentEcommerceModel(order, ticketLines, orderItems, film, site, showtime, i18n)
        ecommerceData.vista_transaction_id = order.transaction?.number
        gtm.sendDataLayer(new EcommerceDataLayer('purchase', ecommerceData))
    }

    // Private methods
}

function getPaymentEcommerceModel(
    order: InProgressOrder | CompletedStandardOrder,
    ticketLines: OrderTicketLine[],
    orderItems: OrderItemLine[],
    film: Film,
    site: Site,
    showtime: Showtime,
    i18n: I18N
): Ecommerce {
    const ticketItems = getTicketItems(ticketLines, film, showtime, site, i18n)
    const concessionItems = getConcessionCartShowtimeItems(orderItems, film, showtime, site, i18n)
    return new Ecommerce(
        [...groupShowtimeItemsByQuantity(concessionItems, true), ...groupShowtimeItemsByQuantity(ticketItems, false)],
        order.totalPrice.valueIncludingTax,
        order.id
    )
}
